import { render, staticRenderFns } from "./ActiveOrder.vue?vue&type=template&id=30f23922&scoped=true"
import script from "./ActiveOrder.vue?vue&type=script&lang=js"
export * from "./ActiveOrder.vue?vue&type=script&lang=js"
import style0 from "./ActiveOrder.vue?vue&type=style&index=0&id=30f23922&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f23922",
  null
  
)

export default component.exports